import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './button.sass'

// TODO: loading prop
const Button = props => {
  const ButtonElement = props.element
  let { type } = props
  if (!type && props.element === 'button') {
    type = 'button'
  }

  return (
    <ButtonElement
      className={classNames(props.className, 'button')}
      type={type}
      disabled={props.isDisabled || props.isLoading}
      onClick={props.onClick}
    >
      {/* TODO: transition of text when change */}
      {!props.isLoading && props.children}
      {props.isLoading && 'loading...'}
    </ButtonElement>
  )
}

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  element: PropTypes.string,
  onClick: PropTypes.func,
}

Button.defaultProps = {
  className: '',
  children: '',
  type: null,
  isDisabled: false,
  isLoading: false,
  element: 'button',
  onClick: () => {},
}

export default Button
